export default __webpack_public_path__ + "static/media/homeIntroTextRightPolygon.61164976.svg";